var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeStyles, withStyles } from '@material-ui/core';
import * as React from 'react';
import { useContext } from 'react';
import { useQaId } from './qa-ids';
import { BaseCheckbox } from './checkbox';
import { BaseInput, inputStyles, ReadOnly } from './inputs';
import { BaseSelect } from './select';
import { BaseTabs } from './tabs';
export var CompactTextArea = function (_a) {
    var label = _a.label, className = _a.className, $value = _a.$value, value = _a.value, readOnly = _a.readOnly, props = __rest(_a, ["label", "className", "$value", "value", "readOnly"]);
    var ro = useContext(ReadOnly) || readOnly || !$value, classes = useCompactInputStyles(props), maybeError = !ro && !props.disabled && $value.error ? ' error' : '';
    return (React.createElement("label", { className: classes.root + ' ' + classes.column + maybeError },
        React.createElement("span", { className: "label" }, label),
        $value && !ro ?
            React.createElement("textarea", __assign({ className: classes.input + maybeError }, props, $value.props)) :
            React.createElement("textarea", __assign({ readOnly: true, className: classes.input, value: $value.value ? $value.value : value }, props))));
};
export var CompactInput = function (_a) {
    var label = _a.label, tooltip = _a.tooltip, props = __rest(_a, ["label", "tooltip"]);
    var ro = useContext(ReadOnly) || props.readOnly || !props.$value || props.disabled, classes = useCompactInputStyles(props), maybeError = !ro && props.$value.error ? ' error' : '';
    var nextId = useQaId(props.id || label);
    return (React.createElement("label", { className: classes.root + ' ' + classes.row + maybeError },
        React.createElement("span", { className: "label filled" }, label),
        React.createElement(BaseInput, __assign({ classes: classes }, props, { "data-qa-id": nextId })),
        tooltip &&
            React.createElement("span", { className: "lqx-tooltip" }, tooltip)));
};
var useCompactInputStyles = makeStyles({
    root: {
        '& .lqx-tooltip': {
            display: 'none',
            zIndex: 2,
            position: 'absolute',
            top: '110%',
            backgroundColor: '#404040',
            color: 'white',
            padding: 8,
            borderRadius: 3,
            maxWidth: 550,
            fontSize: 12,
            boxShadow: '2px 0 4px 0 rgba(0,0,0,0.1)',
        },
        '&:hover .lqx-tooltip': {
            display: 'block',
        },
        display: 'flex',
        border: '1px solid #CEDCE3',
        borderRadius: 2,
        position: 'relative',
        marginTop: function (p) { return p.noMargins ? 0 : 12; },
        marginBottom: function (p) { return p.noMargins ? 0 : 12; },
        backgroundColor: function (props) { return props.disabled ? '#F9F9F9' : 'white'; },
        '&:focus-within': {
            border: '1px solid #1084D3',
            '& span.label': {
                color: '#1084D3',
                '&.filled': {
                    borderRight: '1px solid #1084D3',
                }
            }
        },
        '& span.label': {
            color: '#899095',
            fontSize: 12,
            fontWeight: 600,
            padding: '5px 0px 4px 7px',
            textTransform: 'uppercase'
        },
        '& span.filled': {
            backgroundColor: '#F9F9F9',
            borderRight: '1px solid #CEDCE3',
            minWidth: '16em'
        },
        '&:hover': function (props) { return (props.disabled ? {} : {
            border: '1px solid #1084D3'
        }); },
        '&.error': {
            border: '1px solid #FF274B !important',
            '& span.label': {
                color: '#FF274B !important',
                '&.filled': {
                    borderRight: '1px solid #FF274B !important',
                }
            }
        }
    },
    tooltip: {},
    tabs: {
        display: 'flex',
        justifyContent: function (props) { return props.label ? 'flex-end' : 'center'; },
        padding: 7,
        color: '#899095',
        marginTop: 4,
        marginBottom: 4,
        alignItems: 'center',
        '& .label': {
            fontSize: 12,
            fontWeight: 600,
            textTransform: 'uppercase',
            justifySelf: 'start',
            flexGrow: 2,
            verticalAlign: 'center'
        },
        '& .tab': {
            paddingLeft: '1em',
            paddingRight: '1em',
            fontSize: 13,
            cursor: 'pointer',
            '&.selected': {
                color: '#1084D3',
                borderBottom: '#1084D3 2px solid',
            }
        }
    },
    number: {
        textAlign: 'end'
    },
    column: {
        flexDirection: "column",
    },
    error: {},
    row: {
        flexDirection: 'row',
    },
    input: __assign({}, inputStyles, { flexGrow: 1, borderWidth: 0, color: 'black', fontSize: 12, padding: '5px 7px 4px 7px', fontFamily: 'Montserrat', fontWeight: 600, resize: 'none', '&:focus': {
            outline: 'none',
        }, '&:disabled': {
            opacity: 0.5,
        } })
});
export var CompactSelect = withStyles({
    root: {
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 2,
        display: 'flex',
        border: '1px solid #CEDCE3',
        position: 'relative',
        fontSize: 12,
        fontWeight: 600,
        '& .label': {
            minWidth: '16em'
        },
        '&:focus-within': {
            border: '1px solid #1084D3',
            '& .label': {
                borderRight: '1px solid #1084D3',
            }
        },
        '&.error': {
            border: '1px solid #FF274B !important',
            '& .label': {
                borderRight: '1px solid #FF274B !important',
            }
        },
    },
    label: {
        padding: '5px 7px 4px 7px',
        color: '#899095',
        textTransform: 'uppercase',
        backgroundColor: '#F9F9F9',
        borderRight: '1px solid #CEDCE3',
    },
    selectInputRoot: {},
    selectInput: {
        flexGrow: 1,
        borderWidth: 0,
        fontSize: 12,
        fontFamily: 'Montserrat',
        fontWeight: 600,
        textTransform: 'uppercase',
        '&:focus': {
            outline: 'none',
        },
        '&:disabled': {
            opacity: 0.5,
        }
    },
})(BaseSelect);
export var CompactCheckbox = withStyles({
    label: {
        textTransform: 'uppercase',
    },
})(BaseCheckbox);
export var CompactTabs = function (props) {
    var classes = useCompactInputStyles(props);
    return (React.createElement(BaseTabs, __assign({ classes: classes }, props)));
};
export var FullWidthTabs = withStyles({
    tabs: {
        justifyContent: 'space-between',
        display: 'flex',
        alignItems: 'center',
        margin: 0,
        '& .tab': {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            cursor: 'pointer',
            margin: "0 1px 0 1px",
            width: '100%',
            padding: 4,
            backgroundColor: '#6681a217',
            '&.selected': {
                backgroundColor: 'white',
                fontWeight: 600,
                color: "#1d83ff"
            },
            '& .title': {
                fontWeight: 500,
                fontSize: 14
            },
            '& .body': {
                fontSize: 12
            }
        }
    }
})(BaseTabs);
//# sourceMappingURL=compact.js.map